// The AI's "Hours of Rest report for <crew>, <month> (+ archive)" request, read by the Hours of Rest page from localStorage.
// -> { crew, name, month, archive } for a crew member of the page's list, or { error }
const val = v => (v && typeof v === 'object' && !Array.isArray(v) ? (v.value ?? v.name ?? '') : (v ?? ''))
export const crewFullName = c => (String(val(c['First Name'])) + ' ' + String(val(c['Last Name']))).trim()
export function matchHorRequest(raw, crewList) {
  let req = raw
  if (typeof raw === 'string') { try { req = JSON.parse(raw) } catch (e) { return null } }
  if (!req || typeof req !== 'object') return null
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(String(req.month || ''))) return { error: 'The report request has no valid month.' }
  const want = String(req.crew_name || '').trim().toLowerCase()
  const crew = (crewList || []).find(c => crewFullName(c).toLowerCase() === want)
  if (!crew) return { error: 'No crew member "' + (req.crew_name || '') + '" on this vessel.' }
  return { crew, name: crewFullName(crew), month: req.month, archive: req.archive === true }
}
